(function ($) {
  $(document).ready(function () {
    infoSlider();
    whatsNewSlider();
    locationMap();
    faq();
  });

  //functions
  function faq() {
    $(".faq .question").click(function (e) {
      e.preventDefault();
      $(this).children(".reveal").toggle();
      $(this).children(".hide").toggle();
      $(this).parent().find(".answer").fadeToggle();
    });
  }

  function locationMap() {
    if (document.getElementById("location-map")) {
      // mapboxgl.accessToken = "pk.eyJ1IjoiYmxrZGciLCJhIjoiY2s3MjV0cWNxMDNjcTNscGZkbXd4MWdhdCJ9.cNUUBRDow3j71FWy8S3KyA";
      mapboxgl.accessToken =
        "pk.eyJ1IjoidGhyZWV3ZWF2ZXJzbGEiLCJhIjoiY2t1N2l1dm11MDE2dzJwcDM3MzhranEwNiJ9.vsVxmMCI-xPWe2G21-qDbA";
      // mapboxgl.accessToken = 'pk.eyJ1IjoiY2FuYXJjaHktZGV2IiwiYSI6ImNrdWN1eG1sbzE0ZmwybnFsN3lvbWRuN2wifQ.HGUZ9xnNJ2GVNqaNPitluQ';
      //pk.eyJ1IjoiYmxrZGciLCJhIjoiZ3RIRVZBWSJ9.NB1Ex7JXQvMBRwwW_-npFA

      //get coordinates from DOM
      var lat = $("#location-map").data("lat");
      var lng = $("#location-map").data("lng");

      var geojson = {
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            properties: {
              iconSize: [54, 73],
            },
            geometry: {
              type: "Point",
              coordinates: [lng, lat],
            },
          },
        ],
      };

      var map = new mapboxgl.Map({
        container: "location-map",
        // style: 'mapbox://styles/blkdg/ck5ik5mu20ytt1ipmqh6v0kgm',
        // style: "mapbox://styles/canarchy-dev/ckteobr2m2hrt17qn1h3jhm85",
        style: "mapbox://styles/threeweaversla/ckvcr7chk0vm714o05hhu4hcb",
        center: [lng, lat],
        zoom: 12,
      });

      // add markers to map
      geojson.features.forEach(function (marker) {
        // create a DOM element for the marker
        var el = document.createElement("div");
        el.className = "marker";
        el.style.backgroundImage =
          "url(/wp-content/themes/threeweavers/assets/images/icons/map-locator.svg)";
        el.style.width = marker.properties.iconSize[0] + "px";
        el.style.height = marker.properties.iconSize[1] + "px";

        // add marker to map
        new mapboxgl.Marker(el)
          .setLngLat(marker.geometry.coordinates)
          .addTo(map);
      });
    }
  }

  function whatsNewSlider() {
    if ($(window).width() < 768) {
      $(".whats-new-slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        pauseOnFocus: true,
        variableWidth: true,
      });
      //move bar after slide change
      $(".whats-new-slider").on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
          var init_track_w = $(".slider-bar.whats-new-i .bar-current").data(
            "width"
          );
          if (nextSlide == 0) {
            var track_width = 0;
          } else {
            var track_width = init_track_w * nextSlide;
          }
          $(".slider-bar.whats-new-i .bar-current").css(
            "left",
            track_width + "%"
          );
        }
      );
      //click bar to go to next slide
      $(".slider-bar.whats-new-i .bar-current").click(function (e) {
        e.preventDefault();
        $(".whats-new-slider").slick("slickNext");
      });
    }
  }

  function infoSlider() {
    $(".info-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      autoplay: false,
      // autoplaySpeed: 5000,
      speed: 500,
      pauseOnFocus: false,
      infinite: true,
      responsive: [
        {
          breakpoint: 9999,
          settings: {
            variableWidth: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            variableWidth: false,
          },
        },
      ],
    });
    /*SLIDE ON MOUSE*/
    var scrollCount = null;
    var scroll = null;
    $(".info-slider").on("wheel", function (e) {
      clearTimeout(scroll);
      scroll = setTimeout(function () {
        scrollCount = 0;
      }, 40);
      if (scrollCount) return 0;
      scrollCount = 1;

      if (e.originalEvent.deltaX < 0) {
        e.preventDefault();
        $(this).slick("slickNext");
      }
      if (e.originalEvent.deltaX > 0) {
        e.preventDefault();
        $(this).slick("slickPrev");
      }
    });
    $(".info-slider").show();
    //move bar after slide change
    $(".info-slider").on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        var init_track_w = $(".slider-bar.beer-i .bar-current").data("width");
        if (nextSlide == 0) {
          var track_width = 0;
        } else {
          var track_width = init_track_w * nextSlide;
        }
        $(".slider-bar.beer-i .bar-current").css("left", track_width + "%");
      }
    );
    //click bar to go to next slide
    $(".slider-bar.beer-i .bar-current").click(function (e) {
      e.preventDefault();
      //$('.info-slider').slick('slickNext');
    });

    $(".slider-bar").click(function (e) {
      var pWidth = $(this).innerWidth(); //use .outerWidth() if you want borders
      var pOffset = $(this).offset();
      var x = e.pageX - pOffset.left;
      if (pWidth / 2 > x) $(".info-slider").slick("slickPrev");
      else $(".info-slider").slick("slickNext");
    });
  }
})(jQuery);
